import Navbar from "../Navbar/Navbar";
import "./Header.css";
import React from "react";

const Header = () => {
  return (
    <header className="header center">
      <Navbar />
    </header>
  );
};

export default Header;
